document.querySelectorAll('.jci-clinical-results--data-link[href=""]').forEach ( a => {
  a.addEventListener('click', e => {
    e.preventDefault();
    const this_card = e.target.closest('.jci-clinical-results--data-card');
    const details = this_card.querySelector('.jci-clinical-results--data-card-details');
    const data = this_card.closest('.jci-clinical-results--data');
    data.style['min-height'] = details.offsetHeight + 'px';
    details.style['min-height'] = data.offsetHeight + 'px';

    this_card.classList.add('active');
  });
});

document.querySelectorAll('.jci-clinical-results--details-close').forEach ( el => {
  el.addEventListener('click', e => {
    e.preventDefault();
    const this_card = e.target.closest('.jci-clinical-results--data-card');
    const details = this_card.querySelector('.jci-clinical-results--data-card-details');
    const data = this_card.closest('.jci-clinical-results--data');
    data.style['min-height'] = '';
    details.style['min-height'] = '';

    this_card.classList.remove('active');
  });
});
